import Vue from "vue"
import VueRouter, {RouteConfig} from "vue-router"
import store from "./../store"
import i18n from "../i18n" // Import i18n instance

//PUBLIC
import EmailVerification from "../libs/user/EmailVerification.vue"
import Register from "../libs/user/Register.vue"
import Login from "../libs/user/Login.vue"
import Logout from "../libs/user/Logout.vue"
import ResetPassword from "../libs/user/ResetPassword.vue"
import Invite from "../libs/user/Invite.vue"
import MapView from "../features/map/Map.vue"

//USER
import Plans from "../features/payment-gateway/Plans.vue"
import Checkout from "../features/payment-gateway/Checkout.vue"
import PaymentSuccess from "../features/payment-gateway/Success.vue"
import PaymentCancelled from "../features/payment-gateway/Cancelled.vue"
import Settings from "../features/user/Settings.vue"
import Notifications from "../features/user/Notifications.vue"

import {utils} from "@/libs/utils"
import {cacheSrv} from "@/libs/cache/cache"

Vue.use(VueRouter)

function hasAccess(rolesRequired, userRoles) {
  let allow = false

  if (!rolesRequired || rolesRequired.length == 0) {
    console.log("/Intercept/ - no requirement for any role. Allowing")
    allow = true
    return allow
  }
  rolesRequired = rolesRequired.concat(["SUPER"])

  rolesRequired.forEach((roleRequired) => {
    let requiredAppPrefix = roleRequired.split(":")[0]
    let requiredLevel = roleRequired.indexOf(":") > 0 ? roleRequired.split(":")[1] : 0

    userRoles.forEach((userRole) => {
      let userAppPrefix = userRole.split(":")[0]
      if (requiredAppPrefix == userAppPrefix) {
        let userLevel = userRole.indexOf(":") > 0 ? userRole.split(":")[1] : 0
        if (Number(userLevel) >= Number(requiredLevel)) {
          allow = true
        }
      }
    })
  })

  return allow
}

const routes: Array<RouteConfig> = [
  {
    path: "/plans",
    name: "plans",
    component: Plans,
    meta: {layout: "simple"},
  },
  {
    path: "/checkout/:planId",
    name: "checkout",
    component: Checkout,
    meta: {layout: "simple"},
  },
  {
    path: "/payment/success/:session_id",
    name: "paymentSuccess",
    component: PaymentSuccess,
    meta: {layout: "simple"},
  },
  {
    path: "/payment/canceled",
    name: "paymentCancelled",
    component: PaymentCancelled,
    meta: {layout: "simple"},
  },

  {
    path: "/settings",
    name: "settings",
    component: Settings,
    meta: {layout: "maps", access: ["MAPUSER"]},
  },
  {
    path: "/notifications",
    name: "notifications",
    component: Notifications,
    meta: {layout: "maps", access: ["MAPUSER"]},
  },
  {
    path: "/logout",
    name: "logout",
    meta: {layout: "maps", access: ["MAPUSER"]},
    component: Logout,
  },
  {
    path: "/",
    name: "mapview",
    meta: {layout: "maps", access: ["MAPUSER"]},
    component: MapView,
  },
  {
    path: "/login",
    name: "login",
    meta: {layout: "simple"},
    component: Login,
  },
  {
    path: "/email-verification",
    name: "emailVerification",
    meta: {layout: "simple"},
    component: EmailVerification,
  },
  {
    path: "/register/activate/:key",
    name: "register",
    meta: {layout: "simple"},
    component: Register,
  },
  {
    path: "/register",
    name: "registerEmailVerification",
    meta: {layout: "simple"},
    component: EmailVerification,
  },
  {
    path: "/reset-password/:key",
    name: "resetPassword",
    meta: {layout: "simple"},
    component: ResetPassword,
  },
  {
    path: "/invite/:key",
    name: "invite",
    meta: {layout: "simple"},
    component: Invite,
  },
  {path: "*", redirect: "/"},
].map((i: any) => {
  if (!i.meta) {
    i["meta"] = {layout: "app"}
  }
  if (i["meta"] && i["meta"]["access"]) {
    i.beforeEnter = (to, from, next) => {
      if (!store.state.token) {
        next("/login")
        return
      }

      if (store.state.profile && !hasAccess(i["meta"]["access"], store.state.profile["roles"])) {
        if (to.path == "/") {
          cacheSrv.removeAll()
          store.commit(`logout`)
          next("/login")
          return
        }
        console.log("DENIED ACCESS TO ROUTE", to, i["meta"]["access"], store.state.profile["roles"])
        utils.showSnackbarError("DENIED ACCESS")
        return
      }
      next()
    }
  }
  return i
})

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
})

// Add a global beforeEach guard to handle the "lang" query parameter
router.beforeEach((to, from, next) => {
  const lang = to.query.lang as string
  if (lang && i18n.locale !== lang) {
    i18n.locale = lang
    localStorage.setItem("user-language", lang)
  }
  next()
})

export default router
